import React from 'react';
import { Button, Row, Col, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { CustomTable, GeneralContainer } from '../../../../components';
import { DirectGoodsResponse } from '../../types';
import { ShareResponse } from '../../../../share';
import SearchRow from '../components/Filters';
import CustomAlert from '../../../../components/CustomAlert/CustomAlert';

interface DirectGoodsViewProps {
  data?: DirectGoodsResponse;
  onPagination: (page: number, pageSize: number) => void;
  onViewDetail: (id: string) => void;
  formik: any;
  states?: ShareResponse[];
  isLoading: boolean;
  onResetFilters: () => void;
  supervisors?: ShareResponse[];
  loadingData?: boolean;
}

const DirectGoodsView: React.FC<DirectGoodsViewProps> = ({
  data,
  onPagination,
  onViewDetail,
  formik,
  states,
  isLoading,
  onResetFilters,
  supervisors,
  loadingData,
}) => {
  const columns = [
    {
      title: 'Número de ticket',
      dataIndex: 'ticket',
      key: 'ticket',
      sorter: (a: any, b: any) => a.ticket.localeCompare(b.ticket),
      align: 'center',
    },
    {
      title: 'Tipo de ticket',
      dataIndex: 'ticket_type',
      key: 'ticket_type',
      sorter: (a: any, b: any) =>
        (a.ticket_type || '').localeCompare(b.ticket_type || ''),
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Fecha de solicitud',
      dataIndex: 'transaction_date',
      key: 'transaction_date',
      sorter: (a: any, b: any) =>
        a.transaction_date.localeCompare(b.transaction_date),
      align: 'center',
    },
    {
      title: 'Regional',
      dataIndex: 'regional',
      key: 'regional',
      sorter: (a: any, b: any) => a.regional.localeCompare(b.regional),
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Seccional',
      dataIndex: 'sectional',
      key: 'sectional',
      sorter: (a: any, b: any) => a.sectional.localeCompare(b.sectional),
      align: 'center',
      responsive: ['lg'],
    },
    {
      title: 'Estado de solicitud',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status: any) => {
        return <CustomAlert status={status} />;
      },
    },
    {
      title: 'Solicitante',
      dataIndex: 'requester',
      key: 'requester',
      sorter: (a: any, b: any) => a.requester.localeCompare(b.requester),
      align: 'center',
      render: (_: any, record: any) =>
        record.requester ? `${record.requester}` : '-',
    },
    {
      title: 'Observaciones',
      dataIndex: 'observations',
      key: 'observations',
      sorter: (a: any, b: any) =>
        (a.observations || '').localeCompare(b.observations || ''),
      align: 'center',
      responsive: ['lg'],
      width: 300,
      render: (text: string) => {
        return (
          <Tooltip title={text || 'Sin registro'}>
            <div
              style={{
                maxWidth: 250,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                margin: '0 auto',
              }}
            >
              {text || 'Sin registro'}
            </div>
          </Tooltip>
        );
      },
    },
    {
      title: 'Acciones',
      key: 'actions',
      align: 'center',
      render: (_: any, record: any) => (
        <>
          <Tooltip title="Ver solicitud">
            <Button
              type="link"
              icon={<EyeOutlined />}
              onClick={() => {
                onViewDetail(record);
              }}
            />
          </Tooltip>
        </>
      ),
    },
  ];

  return (
    <GeneralContainer
      title="Salidas de consumo directas"
      isLoading={loadingData}
    >
      {/* Filtros */}
      <Row gutter={[16, 16]} style={{ marginBottom: '16px' }}>
        <Col xs={24}>
          <SearchRow
            formik={formik}
            states={states}
            supervisors={supervisors}
            onCancel={onResetFilters}
            isLoading={isLoading}
          />
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <CustomTable
            loading={isLoading}
            columns={columns as any}
            rowKey={(record) => record.id}
            dataSource={
              data?.data?.map((entry) => ({
                ...entry,
                id: Number(entry.id) || -1,
              })) || []
            }
            paginationConfig={{
              current: data?.current_page,
              pageSize: data?.per_page,
              total: data?.total,
              onChange: onPagination,
            }}
            scroll={{ x: 'max-content' }}
          />
        </Col>
      </Row>
    </GeneralContainer>
  );
};

export default DirectGoodsView;
